import { render, staticRenderFns } from "./UmDbCard.vue?vue&type=template&id=19fed09e&scoped=true&"
import script from "./UmDbCard.vue?vue&type=script&lang=js&"
export * from "./UmDbCard.vue?vue&type=script&lang=js&"
import style0 from "./UmDbCard.vue?vue&type=style&index=0&id=19fed09e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fed09e",
  null
  
)

export default component.exports